module.exports = __webpack_public_path__ + "static/media/model-l200-91.37cc61d0.jpg";